module.exports = __webpack_public_path__ + "static/media/facebook-violet.af76b4c2.svg";